import { render, staticRenderFns } from "./_NtuGymAndSportsMembership.vue?vue&type=template&id=4a928e9e&"
import script from "./_NtuGymAndSportsMembership.vue?vue&type=script&lang=js&"
export * from "./_NtuGymAndSportsMembership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports